// TODO: create enums to join similar entities and eliminate long prefixes
export const MODEL_ENTITY_RULE = 'rule'
export const MODEL_ENTITY_ACTION = 'action'
export const MODEL_ENTITY_APP = 'app'

export const APP_BLOCK_MODULE = 'module'
export const APP_BLOCK_CONNECTION = 'connection'

export const WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES = 'workflow.properties' // singleton for global properties

export const WORKFLOW_OBJ_TYPE_WORKFLOW_DATA = 'workflow.data'
export const WORKFLOW_OBJ_TYPE_MAP = 'map'
export const WORKFLOW_OBJ_TYPE_MODULE_INTERFACE = 'module.interface'
export const WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE = 'module.error.interface'
export const WORKFLOW_OBJ_TYPE_LOOP_ITEM = 'loop-item'
export const WORKFLOW_OBJ_TYPE_CREATED = 'created'
export const WORKFLOW_OBJ_TYPE_FETCHED = 'fetched'
export const WORKFLOW_OBJ_TYPE_ERROR = 'error'
export const WORKFLOW_OBJ_TYPE_RULE_RESULT = 'rule-result'
export const WORKFLOW_OBJ_TYPE_APPROVE = 'approve'
export const WORKFLOW_OBJ_TYPE_DECLINE = 'decline'
export const WORKFLOW_OBJ_TYPE_DATASTORE_LIST = 'datastore.list'

export const WORKFLOW_NOTE = 'note'

export const WORKFLOW_PATH_TRUE = 'true_path'
export const WORKFLOW_PATH_FALSE = 'false_path'
export const WORKFLOW_PATH_SUCCESS = 'success_path'
export const WORKFLOW_PATH_ERROR = 'error_path'
export const WORKFLOW_PATH_EMPTY = 'empty_path'
export const WORKFLOW_PATH_BEGIN = 'begin_path'
export const WORKFLOW_PATH_END = 'end_path'
export const WORKFLOW_PATH_GROUP_ENTRY = 'entry_path'
export const WORKFLOW_PATH_GROUP_EXIT = 'exit_path'

export const RULE_STATEMENT = 'rule.statement'
export const RULE_STATEMENT_OBJ = 'rule.statement_obj'
export const RULE_EXPRESSION = 'rule.expression'
export const RULE_EXPRESSION_EVALUATE = 'rule.expression_evaluate' // like expression except it return an object
export const RULE_TRUTH_TABLE = 'rule.truth_table'
export const RULE_MATRIX = 'rule.matrix'
export const RULE_TREE = 'rule.tree'
export const RULE_VALIDATE_DATA = 'rule.validate_data'

export const VALIDATE_DATA_TYPE_SIMPLE = 'simple'
export const VALIDATE_DATA_TYPE_ADVANCED = 'advanced'

export const ACTION_START = 'action_start'
export const ACTION_END = 'action_end'
export const ACTION_APPROVAL = 'action.approval'
export const ACTION_RUN_WORKFLOW = 'action.run_workflow'
export const ACTION_DATASTORE = 'action.datastore'
export const ACTION_DATASTORE_OPERATION = 'action.dataoperation'
export const ACTION_TRIGGER_ACKNOWLEDGE = 'action.trigger_acknowledge'
export const ACTION_FOR_EACH = 'action.for_each'
export const ACTION_FOR_EACH_BREAK = 'action.for_each_break'
export const ACTION_FOR_EACH_CONTINUE = 'action.for_each_continue'
export const ACTION_JOIN = 'action.join'
export const ACTION_SPLIT = 'action.split'
export const ACTION_WAIT = 'action.wait'
export const ACTION_SEND_EMAIL = 'action.send_email'
export const ACTION_SEND_NOTIFICATION = 'action.send_notification'
export const ACTION_CATCH_OUTCOME = 'action.catch_outcome'
export const ACTION_CATCH_EXCEPTION = 'action.catch_exception'

// export const ACTION_SET_STATUS = 'action.set_status'
// export const ACTION_ADD_NOTE = 'action.add_note'
// export const ACTION_ADD_LOG = 'action.add_log'
// export const ACTION_SEND_TO_INTEGRATION = 'action.send_to_integration'
// export const ACTION_UPDATE_FIELD = 'action.update_field'
// export const ACTION_CREATE_LINE_ITEM = 'action.create_line_item'
